import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

// Firebase configuration for Video Analysis Platform
// Using the same Firebase project as SDK Backend: solo-sdk-a0179
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "solo-sdk-a0179.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "solo-sdk-a0179",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "solo-sdk-a0179.appspot.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Validate Firebase configuration
const missingKeys = Object.entries(firebaseConfig)
  .filter(([key, value]) => !value || (typeof value === 'string' && value.includes('XXXXX')))
  .map(([key]) => key);

if (missingKeys.length > 0) {
  console.error('❌ Missing Firebase configuration keys:', missingKeys);
  console.error(`
🔥 Firebase Configuration Required:
Please add these environment variables to your deployment:

VITE_FIREBASE_API_KEY=your_api_key_here
VITE_FIREBASE_MESSAGING_SENDER_ID=your_sender_id_here  
VITE_FIREBASE_APP_ID=your_app_id_here

Or get them from: https://console.firebase.google.com/project/solo-sdk-a0179/settings/general
  `);
  
  // For development, you might want to throw an error
  // throw new Error('Firebase configuration incomplete');
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);

// Connect to Firebase Auth emulator in development
if (import.meta.env.DEV && import.meta.env.VITE_FIREBASE_USE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099');
  console.log('[firebase] Connected to Authentication emulator');
}

export { auth };
export default app;
